import { GraphQLFloat, GraphQLID, GraphQLInt } from "graphql";
export const Int = GraphQLInt;
export const Float = GraphQLFloat;
export const ID = GraphQLID;
